import { ProjectRenderer } from '../ProjectRenderer';
import { CreatorLandscapeModule } from '@/api/CreatorLandscapeModuleApi';
import { CollidableObject } from './CollidableObject';
import {
	CollidableObjectSerializeData,
	UserDataObjectType,
	UserDataProp,
} from '../types';
import RENDERER_CONFIG from '@/configs/rendererConfig';

export interface SerializedLandscapeModule
	extends CollidableObjectSerializeData {
	creatorLandscapeModule: CreatorLandscapeModule;
}

export class LandscapeModule extends CollidableObject {
	private creatorLandscapeModule: CreatorLandscapeModule;

	constructor(
		renderer: ProjectRenderer,
		creatorLandscapeModule: CreatorLandscapeModule
	) {
		super(renderer, creatorLandscapeModule.refId);
		this.collisionsEnabled = false;

		this.creatorLandscapeModule = creatorLandscapeModule;
	}

	async loadAsset(src: string) {
		const model = await this.assetsLib.getModel(src);

		model.traverse((child) => {
			child.userData[UserDataProp.OBJECT_TYPE] =
				UserDataObjectType.COLLIDABLE_OBJECT;
			child.userData[UserDataProp.OBJECT_ID] = this.id;
			child.layers.set(RENDERER_CONFIG.COLLIDABLE_MODULE.LAYER);
			child.castShadow = true;
			child.receiveShadow = true;
		});

		this.group.add(model);
	}

	export(): SerializedLandscapeModule {
		return {
			collisionsEnabled: this.collisionsEnabled,
			creatorLandscapeModule: this.creatorLandscapeModule,
			isCorrect: this.isCorrect,
			position: [this.group.position.x, this.group.position.z],
			rotation: this.group.rotation.y,
			collidedModules: Array.from(this.collidedModules),
		};
	}
}
